import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { FlowRevision } from '../types/FlowRevision';

export interface GetFlowVersionsParams extends IGetItemsParams {
}

export interface GetFlowVersionsResult extends IGetItemsResult {
  versions: FlowRevision[];
}

export class GetFlowVersionsRequest extends Request<GetFlowVersionsParams, GetFlowVersionsResult> {
  constructor(params: GetFlowVersionsParams) {
    super('getFlowVersions', params);
  }
}
